import { Card, Text, Divider } from "@nextui-org/react";
import { motion } from "framer-motion";
import { useMemo } from "react";
import { Link } from "react-router-dom";

const MotionCard = motion(Card);

export const TotalCard = ({ data }) => {
  const totalCalc = useMemo(() => {
    let total = 0,
      products = 0,
      cash = 0,
      online = 0,
      card = 0,
      cashfree = 0,
      ma = 0,
      udhar = 0,
      replace = 0,
      exchange = 0;

    data.forEach((doc) => {
      total += doc.total;
      products += doc.products;
      cash += (doc.cash ?? 0) + (doc.otherCash ?? 0);
      online += (doc.online ?? 0) + (doc.otherBank ?? 0);
      card += (doc.card ?? 0) + (doc.otherCard ?? 0);
      cashfree += (doc.cashfree ?? 0) + (doc.otherCashfree ?? 0);
      ma += (doc.ma ?? 0) + (doc.otherMa ?? 0);
      udhar += (doc.udhar ?? 0) + (doc.otherLoaned ?? 0);
      replace += doc.otherReplace ?? 0;
      exchange += doc.otherExchange ?? 0;
    });

    return {
      total,
      products,
      cash,
      online,
      card,
      cashfree,
      ma,
      udhar,
      replace,
      exchange,
    };
  }, [data]);

  const td = useMemo(() => {
    return (totalCalc.online + totalCalc.card + totalCalc.cashfree) * 0.02;
  }, [totalCalc]);

  return (
    <>
      <MotionCard
        variant="bordered"
        css={{ mw: "550px", cursor: "pointer", bg: "#0072f5" }}
        whileTap={{ scale: 0.9, transition: { duration: 0.1 } }}
      >
        <Card.Header
          css={{
            display: "inline-flex",
            justifyContent: "space-between",
            alignItems: "center",
            py: "5px",
          }}
        >
          <Text b color="#fff" size="16px">
            Total
          </Text>
          <Text b color="#fff" size="16px">
            &#8377; {totalCalc.total?.toLocaleString("en-in")}
          </Text>
        </Card.Header>
        <Card.Divider />
        <Card.Body
          css={{
            display: "flex",
            flexDirection: "column",
            gap: "5px",
            py: "5px",
            alignItems: "center",
          }}
        >
          <div className="groupCardFlex">
            <Text b color="#fff" size="16px">
              Total Products
            </Text>
            <Text b color="#fff" size="16px">
              {totalCalc.products} Products
            </Text>
          </div>
          <Divider css={{ bgColor: "rgba(255,255,255,0.3)" }} />
          <div className="groupCardFlex">
            <Text color="#fff" size="14px">
              Cash
            </Text>
            <Text color="#fff" size="14px">
              &#8377; {totalCalc.cash?.toLocaleString("en-in")}
            </Text>
          </div>
          <Divider css={{ bgColor: "rgba(255,255,255,0.3)" }} />
          <div className="groupCardFlex">
            <Text color="#fff" size="14px">
              Online
            </Text>
            <Text color="#fff" size="14px">
              &#8377; {totalCalc.online?.toLocaleString("en-in")}
            </Text>
          </div>
          <Divider css={{ bgColor: "rgba(255,255,255,0.3)" }} />
          <div className="groupCardFlex">
            <Text color="#fff" size="14px">
              Card
            </Text>
            <Text color="#fff" size="14px">
              &#8377; {totalCalc.card?.toLocaleString("en-in")}
            </Text>
          </div>
          <Divider css={{ bgColor: "rgba(255,255,255,0.3)" }} />
          <div className="groupCardFlex">
            <Text color="#fff" size="14px">
              Cashfree
            </Text>
            <Text color="#fff" size="14px">
              &#8377; {totalCalc.cashfree?.toLocaleString("en-in")}
            </Text>
          </div>
          <Divider css={{ bgColor: "rgba(255,255,255,0.3)" }} />
          <div className="groupCardFlex">
            <Text color="#fff" size="14px">
              MA
            </Text>
            <Text color="#fff" size="14px">
              &#8377; {totalCalc.ma?.toLocaleString("en-in")}
            </Text>
          </div>
          <Divider css={{ bgColor: "rgba(255,255,255,0.3)" }} />
          <div className="groupCardFlex">
            <Text color="#fff" size="14px">
              Udhar
            </Text>
            <Text color="#fff" size="14px">
              &#8377; {totalCalc.udhar?.toLocaleString("en-in")}
            </Text>
          </div>
          <Divider css={{ bgColor: "rgba(255,255,255,0.3)" }} />
          <div className="groupCardFlex">
            <Text color="#fff" size="14px">
              Replace
            </Text>
            <Text color="#fff" size="14px">
              &#8377; {totalCalc.replace?.toLocaleString("en-in")}
            </Text>
          </div>
          <Divider css={{ bgColor: "rgba(255,255,255,0.3)" }} />
          <div className="groupCardFlex">
            <Text color="#fff" size="14px">
              Exchange
            </Text>
            <Text color="#fff" size="14px">
              &#8377; {totalCalc.exchange?.toLocaleString("en-in")}
            </Text>
          </div>
          <Divider css={{ bgColor: "rgba(255,255,255,0.3)" }} />
          <div className="groupCardFlex">
            <Text color="#fff" size="14px">
              TD
            </Text>
            <Text color="#fff" size="14px">
              {Math.ceil(td)?.toLocaleString("en-in")}
            </Text>
          </div>
        </Card.Body>
      </MotionCard>
    </>
  );
};

const GroupCard = (props) => {
  return (
    <Link
      to={`/analytics/details`}
      state={{ doc: props.doc }}
      className="linkWidth"
    >
      <MotionCard
        variant="bordered"
        css={{ mw: "550px", cursor: "pointer" }}
        whileTap={{ scale: 0.9, transition: { duration: 0.1 } }}
      >
        <Card.Header
          css={{
            display: "inline-flex",
            justifyContent: "space-between",
            alignItems: "center",
            py: "5px",
          }}
        >
          <Text b size="14px">
            {props.doc._id}
          </Text>
          <Text
            b
            size="12px"
            css={{ br: "12px", bgColor: "$purple50", px: "10px", py: "5px" }}
            color="$purple800"
          >
            {props.doc.orders.length}&nbsp;Orders
          </Text>
        </Card.Header>
        <Card.Divider />
        <Card.Body
          css={{
            display: "flex",
            flexDirection: "column",
            gap: "5px",
            py: "5px",
            alignItems: "center",
          }}
        >
          <div className="groupCardFlex">
            <Text size="13px" b>
              Total
            </Text>
            <Text size="13px" b>
              &#8377;{props.doc.total}
            </Text>
          </div>
          <Divider />
          <div className="groupCardFlex">
            <Text size="13px" b>
              Products
            </Text>
            <Text size="13px" b>
              {props.doc.products} Sold
            </Text>
          </div>
        </Card.Body>
      </MotionCard>
    </Link>
  );
};

export default GroupCard;
